var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tab-REGULAR" },
    [
      !_vm.betslipLayout2
        ? [
            _vm.betsNo > 1
              ? _c("div", { staticClass: "PARLAYS" }, [
                  _vm.activeSelectionsNo > 1 &&
                  _vm.allowedBetTypesAndReturns.PerBetType.A
                    ? _c(
                        "div",
                        [
                          _vm.currentBetSlipState <= 1 || _vm.parlayStake
                            ? _c("bet-type-parlay", {
                                key: "A",
                                attrs: {
                                  id: "A",
                                  currentBetSlipState: _vm.currentBetSlipState,
                                  tab: _vm.tab,
                                  allowedBetTypesAndReturns:
                                    _vm.allowedBetTypesAndReturns.PerBetType.A,
                                  gettingABTnR: _vm.gettingABTnR
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.activeSelectionsNo > 1 &&
                  _vm.showParlayInfoMsg &&
                  _vm.currentBetSlipState <= 1 &&
                  !_vm.allowedBetTypesAndReturns.PerBetType.A &&
                  (!_vm.isSGMenabled || (_vm.isSGMenabled && !_vm.hasSGM))
                    ? _c("div", [
                        _c(
                          "div",
                          {
                            staticClass:
                              "msg info all_corners NoParlayAvailable",
                            class: {
                              interRelated: _vm.hasActiveInteRelated,
                              NotAllSelectionsCombinableInParlay: !_vm.allSelectionsCombinableInParlay
                            }
                          },
                          [
                            _c("v-icon", [_vm._v("info_outline")]),
                            _vm._v(" "),
                            _vm.hasActiveInteRelated &&
                            _vm.allSelectionsCombinableInParlay
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "BetSlip.tab.PARLAY.info.interRelated"
                                      )
                                    )
                                  )
                                ])
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "BetSlip.tab.PARLAY.info.notAvailable"
                                      )
                                    )
                                  )
                                ])
                          ],
                          1
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isSGMenabled && _vm.betsNo >= 2 && _vm.hasSGM
                    ? _c(
                        "div",
                        [
                          _c("sgm", {
                            attrs: {
                              betsNo: _vm.betsNo,
                              tab: "SGM",
                              allowedBetTypesAndReturns:
                                _vm.allowedBetTypesAndReturnsXP,
                              currentBetSlipState: _vm.currentBetSlipState,
                              gettingABTnR: _vm.gettingABTnR
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.betsNo
              ? _c(
                  "div",
                  { staticClass: "STRAIGHTS" },
                  [
                    _vm.currentBetSlipState <= 1 ||
                    _vm.parlayStake ||
                    _vm.singlesStakes.length
                      ? _c(
                          "div",
                          {
                            staticClass: "header-SING",
                            class: {
                              focused: _vm.focus[0],
                              "non-empty": !!_vm.multiSinglesStake
                            }
                          },
                          [
                            _c("h2", { key: _vm.betsNo }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "BetSlip.tab.title.SINGLE" +
                                      (_vm.betsNo > 1 ? "S" : "")
                                  )
                                )
                              )
                            ]),
                            _vm._v(" "),
                            _vm.wagerAllSingles
                              ? _c(
                                  "span",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.betsNo > 1 &&
                                          _vm.currentBetSlipState < 1,
                                        expression:
                                          "betsNo>1 && currentBetSlipState<1"
                                      }
                                    ],
                                    staticClass: "stakeAll"
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "multiSinglesStake" },
                                      [
                                        _c("money-input", {
                                          attrs: {
                                            id: 1,
                                            placeholder: _vm.$t(
                                              "BetSlip.single.wagerAll"
                                            ),
                                            disabled:
                                              _vm.currentBetSlipState >= 1,
                                            focus: _vm.focus,
                                            className: "input-only"
                                          },
                                          on: {
                                            setFocus: _vm.setFocus,
                                            dismissError: _vm.dismissError
                                          },
                                          model: {
                                            value: _vm.multiSinglesStake,
                                            callback: function($$v) {
                                              _vm.multiSinglesStake = $$v
                                            },
                                            expression: "multiSinglesStake"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.betslipSelectionIds, function(id) {
                      return _vm.currentBetSlipState <= 1 ||
                        _vm.betTypeStakes.PerSelection[id] ||
                        _vm.parlayStake
                        ? _c("selection-regular", {
                            key: id,
                            attrs: {
                              id: id,
                              currentBetSlipState: _vm.currentBetSlipState,
                              tab: _vm.tab,
                              allowedBetTypesAndReturns:
                                _vm.allowedBetTypesAndReturns.PerSelection,
                              parlayStake: _vm.parlayStake,
                              betsNo: _vm.betsNo,
                              allowedMultiSingles: _vm.allowedMultiSingles
                            }
                          })
                        : _vm._e()
                    })
                  ],
                  2
                )
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.betslipLayout2
        ? [
            _vm.betsNo
              ? _c(
                  "div",
                  { staticClass: "STRAIGHTS" },
                  _vm._l(_vm.betslipSelectionIds, function(id) {
                    return _vm.currentBetSlipState <= 1 ||
                      _vm.betTypeStakes.PerSelection[id] ||
                      _vm.parlayStake
                      ? _c("selection-regular", {
                          key: id,
                          attrs: {
                            id: id,
                            currentBetSlipState: _vm.currentBetSlipState,
                            tab: _vm.tab,
                            allowedBetTypesAndReturns:
                              _vm.allowedBetTypesAndReturns.PerSelection,
                            parlayStake: _vm.parlayStake,
                            betsNo: _vm.betsNo,
                            allowedMultiSingles: _vm.allowedMultiSingles
                          }
                        })
                      : _vm._e()
                  }),
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.betsNo > 1
              ? _c("div", { staticClass: "PARLAYS" }, [
                  _vm.isSGMenabled && _vm.betsNo >= 2 && _vm.hasSGM
                    ? _c(
                        "div",
                        [
                          _c("sgm", {
                            attrs: {
                              betsNo: _vm.betsNo,
                              tab: "SGM",
                              allowedBetTypesAndReturns:
                                _vm.allowedBetTypesAndReturnsXP,
                              currentBetSlipState: _vm.currentBetSlipState,
                              gettingABTnR: _vm.gettingABTnR
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.activeSelectionsNo > 1 &&
                  _vm.allowedBetTypesAndReturns.PerBetType.A
                    ? _c(
                        "div",
                        [
                          _vm.currentBetSlipState <= 1 || _vm.parlayStake
                            ? _c("bet-type-parlay", {
                                key: "A",
                                attrs: {
                                  id: "A",
                                  currentBetSlipState: _vm.currentBetSlipState,
                                  tab: _vm.tab,
                                  allowedBetTypesAndReturns:
                                    _vm.allowedBetTypesAndReturns.PerBetType.A,
                                  gettingABTnR: _vm.gettingABTnR
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.activeSelectionsNo > 1 &&
                  _vm.showParlayInfoMsg &&
                  _vm.currentBetSlipState <= 1 &&
                  !_vm.allowedBetTypesAndReturns.PerBetType.A &&
                  (!_vm.isSGMenabled || (_vm.isSGMenabled && !_vm.hasSGM))
                    ? _c("div", [
                        _c(
                          "div",
                          {
                            staticClass:
                              "msg info all_corners NoParlayAvailable",
                            class: {
                              interRelated: _vm.hasActiveInteRelated,
                              NotAllSelectionsCombinableInParlay: !_vm.allSelectionsCombinableInParlay
                            }
                          },
                          [
                            _c("v-icon", [_vm._v("info_outline")]),
                            _vm._v(" "),
                            _vm.hasActiveInteRelated &&
                            _vm.allSelectionsCombinableInParlay
                              ? _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "BetSlip.tab.PARLAY.info.interRelated"
                                      )
                                    )
                                  )
                                ])
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "BetSlip.tab.PARLAY.info.notAvailable"
                                      )
                                    )
                                  )
                                ])
                          ],
                          1
                        )
                      ])
                    : _vm._e()
                ])
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-42c17d34", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42c17d34","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/betslipV2/rootElements/tabs/tabRegular.vue
// module id = null
// module chunks = 